import Component from '@glimmer/component';
import { service } from '@ember/service';

import ProjectsAbstractStatusComponent from 'seshy/components/projects/abstract/status';

export default class ProjectsNativeStatusComponent extends ProjectsAbstractStatusComponent {}
